import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientInputModule } from './client-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { ClientListComponent } from './client-list/client-list.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ProfileComponent } from './profile/profile.component';
import { RouterModule, Routes } from '@angular/router';
import { CreateCarComponent } from './create-car/create-car.component';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { ClientListNewComponent } from './client-list-new/client-list-new.component';
import { ClientListItemNewComponent } from './client-list-item-new/client-list-item-new.component';
import { MatCardModule } from '@angular/material/card';
import { MainInfoComponent } from './profile/main-info/main-info.component';
import { CarsComponent } from './profile/cars/cars.component';
import { OrderListModule } from '../order/list/order-list.module';
import { ClientReportsComponent } from './profile/reports/client-reports.component';
import { ClientMarkupTableComponent } from './profile/markup/client-markup-table.component';
import { ClientMarkupCreateComponent } from './profile/markup/client-markup-create.component';
import { CallHistoryComponent } from './profile/call-history/call-history.component';
import { FolderModule } from '../folder/folder.module';
import { BrandModule } from '../brand/brand.module';
import { MarkupRulesTableModule } from '../markup-table/rules-table/markup-rules-table.module';
import { SelectorModule } from '../selector/selector.module';
import { CustomerAccountModule } from '../customer-account/customer-account.module';

const maskConfig: Partial<IConfig> = {
  validation: false
};

const routes: Routes = [
  {
    path: 'profile/:id',
    component: ProfileComponent
  }
];

@NgModule({
  declarations: [
    ClientListComponent,
    ProfileComponent,
    CreateCarComponent,
    ClientListNewComponent,
    ClientListItemNewComponent,
    MainInfoComponent,
    CarsComponent,
    ClientReportsComponent,
    ClientMarkupTableComponent,
    ClientMarkupCreateComponent,
    CallHistoryComponent
  ],
  imports: [
    CommonModule,
    CustomerAccountModule,
    ClientInputModule,
    OrderListModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    FolderModule,
    BrandModule,
    MarkupRulesTableModule,
    SelectorModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSelectModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatTabsModule,
    MatDialogModule,
    MatTableModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatButtonToggleModule,
    NgxMaskModule.forRoot(maskConfig)
  ],
  exports: [ClientInputModule, ClientListNewComponent]
})
export class ClientModule {}
